
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDropDownGoogle as ObiDropDownGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-drop-down-google.js';
 
 
 

 
 export const ObiDropDownGoogle = createComponent({
   react: React,
   tagName: 'obi-drop-down-google',
   elementClass: ObiDropDownGoogleElement,
   events: {
     
   }
  });
 
 